<template>
  <div class="mypage">
    <InformationComponent class="mb-3"/>
    <LessonComponent class="mb-3"/>
    <ToDoDeadlineComponent class="mb-3"/>
  </div>
</template>

<script>
import LessonComponent from '@/components/parts/mypage/LessonComponent.vue';
import ToDoDeadlineComponent from '@/components/parts/mypage/ToDoDeadlineComponent.vue';
import InformationComponent from '@/components/parts/mypage/InformationComponent.vue';

export default {
  components: {
    InformationComponent,
    LessonComponent,
    ToDoDeadlineComponent,
  },
};
</script>
